import App from "./App";
import OverlayProvider from "./gui/Overlay/OverlayProvider";
import SnackbarProvider from "./gui/Snackbar/SnackbarProvider";
import PathProvider from "./libs/path/PathProvider";
import "./scss/index.scss"
import 'react-perfect-scrollbar/dist/css/styles.css';

import ReactDOM from "react-dom/client";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import LoginProvider from "./gui/Login/LoginProvider";
import PassApi from "./data/PassApi";
import AuthProvider from "./gui/Login/AuthProvider";
import PasswordProvider from "./data/PasswordProvider";

(() => {
    PassApi.i.init()
    
    const root = ReactDOM.createRoot(document.getElementById("root")!)
    root.render(
    <AuthProvider api={PassApi.i}>
    <PasswordProvider>
    <PathProvider><SnackbarProvider><OverlayProvider>
        <LoginProvider api={PassApi.i} required={true}>
            <App/>
        </LoginProvider>
    </OverlayProvider></SnackbarProvider></PathProvider>
    </PasswordProvider>
    </AuthProvider>
    )

    serviceWorkerRegistration.register()

})()